export class GlobalClass {

    public static navbarTitle: string = "ZOTI";

    backgroundStyle(firstColorVar : any){
        let secondColorVar = '#314755';
        return {
          background: `linear-gradient(
            to right,
            ${secondColorVar} 0%,
            ${firstColorVar} 31%,
            ${secondColorVar} 100%
          )`,      
        };
      }



    public static CountryCodes : any[] = [
        {
            name: "Afghanistan",
            number: "+93",
            code: "AF"
            },
            {
            name: "Aland Islands",
            number: "+358",
            code: "AX"
            },
            {
            name: "Albania",
            number: "+355",
            code: "AL"
            },
            {
            name: "Algeria",
            number: "+213",
            code: "DZ"
            },
            {
            name: "AmericanSamoa",
            number: "+1684",
            code: "AS"
            },
            {
            name: "Andorra",
            number: "+376",
            code: "AD"
            },
            {
            name: "Angola",
            number: "+244",
            code: "AO"
            },
            {
            name: "Anguilla",
            number: "+1264",
            code: "AI"
            },
            {
            name: "Antarctica",
            number: "+672",
            code: "AQ"
            },
            {
            name: "Antigua and Barbuda",
            number: "+1268",
            code: "AG"
            },
            {
            name: "Argentina",
            number: "+54",
            code: "AR"
            },
            {
            name: "Armenia",
            number: "+374",
            code: "AM"
            },
            {
            name: "Aruba",
            number: "+297",
            code: "AW"
            },
            {
            name: "Australia",
            number: "+61",
            code: "AU"
            },
            {
            name: "Austria",
            number: "+43",
            code: "AT"
            },
            {
            name: "Azerbaijan",
            number: "+994",
            code: "AZ"
            },
            {
            name: "Bahamas",
            number: "+1242",
            code: "BS"
            },
            {
            name: "Bahrain",
            number: "+973",
            code: "BH"
            },
            {
            name: "Bangladesh",
            number: "+880",
            code: "BD"
            },
            {
            name: "Barbados",
            number: "+1246",
            code: "BB"
            },
            {
            name: "Belarus",
            number: "+375",
            code: "BY"
            },
            {
            name: "Belgium",
            number: "+32",
            code: "BE"
            },
            {
            name: "Belize",
            number: "+501",
            code: "BZ"
            },
            {
            name: "Benin",
            number: "+229",
            code: "BJ"
            },
            {
            name: "Bermuda",
            number: "+1441",
            code: "BM"
            },
            {
            name: "Bhutan",
            number: "+975",
            code: "BT"
            },
            {
            name: "Bolivia, Plurinational State of",
            number: "+591",
            code: "BO"
            },
            {
            name: "Bosnia and Herzegovina",
            number: "+387",
            code: "BA"
            },
            {
            name: "Botswana",
            number: "+267",
            code: "BW"
            },
            {
            name: "Brazil",
            number: "+55",
            code: "BR"
            },
            {
            name: "British Indian Ocean Territory",
            number: "+246",
            code: "IO"
            },
            {
            name: "Brunei Darussalam",
            number: "+673",
            code: "BN"
            },
            {
            name: "Bulgaria",
            number: "+359",
            code: "BG"
            },
            {
            name: "Burkina Faso",
            number: "+226",
            code: "BF"
            },
            {
            name: "Burundi",
            number: "+257",
            code: "BI"
            },
            {
            name: "Cambodia",
            number: "+855",
            code: "KH"
            },
            {
            name: "Cameroon",
            number: "+237",
            code: "CM"
            },
            {
            name: "Canada",
            number: "+1",
            code: "CA"
            },
            {
            name: "Cape Verde",
            number: "+238",
            code: "CV"
            },
            {
            name: "Cayman Islands",
            number: "+ 345",
            code: "KY"
            },
            {
            name: "Central African Republic",
            number: "+236",
            code: "CF"
            },
            {
            name: "Chad",
            number: "+235",
            code: "TD"
            },
            {
            name: "Chile",
            number: "+56",
            code: "CL"
            },
            {
            name: "China",
            number: "+86",
            code: "CN"
            },
            {
            name: "Christmas Island",
            number: "+61",
            code: "CX"
            },
            {
            name: "Cocos (Keeling) Islands",
            number: "+61",
            code: "CC"
            },
            {
            name: "Colombia",
            number: "+57",
            code: "CO"
            },
            {
            name: "Comoros",
            number: "+269",
            code: "KM"
            },
            {
            name: "Congo",
            number: "+242",
            code: "CG"
            },
            {
            name: "Congo, The Democratic Republic of the Congo",
            number: "+243",
            code: "CD"
            },
            {
            name: "Cook Islands",
            number: "+682",
            code: "CK"
            },
            {
            name: "Costa Rica",
            number: "+506",
            code: "CR"
            },
            {
            name: "Cote d'Ivoire",
            number: "+225",
            code: "CI"
            },
            {
            name: "Croatia",
            number: "+385",
            code: "HR"
            },
            {
            name: "Cuba",
            number: "+53",
            code: "CU"
            },
            {
            name: "Cyprus",
            number: "+357",
            code: "CY"
            },
            {
            name: "Czech Republic",
            number: "+420",
            code: "CZ"
            },
            {
            name: "Denmark",
            number: "+45",
            code: "DK"
            },
            {
            name: "Djibouti",
            number: "+253",
            code: "DJ"
            },
            {
            name: "Dominica",
            number: "+1767",
            code: "DM"
            },
            {
            name: "Dominican Republic",
            number: "+1849",
            code: "DO"
            },
            {
            name: "Ecuador",
            number: "+593",
            code: "EC"
            },
            {
            name: "Egypt",
            number: "+20",
            code: "EG"
            },
            {
            name: "El Salvador",
            number: "+503",
            code: "SV"
            },
            {
            name: "Equatorial Guinea",
            number: "+240",
            code: "GQ"
            },
            {
            name: "Eritrea",
            number: "+291",
            code: "ER"
            },
            {
            name: "Estonia",
            number: "+372",
            code: "EE"
            },
            {
            name: "Ethiopia",
            number: "+251",
            code: "ET"
            },
            {
            name: "Falkland Islands (Malvinas)",
            number: "+500",
            code: "FK"
            },
            {
            name: "Faroe Islands",
            number: "+298",
            code: "FO"
            },
            {
            name: "Fiji",
            number: "+679",
            code: "FJ"
            },
            {
            name: "Finland",
            number: "+358",
            code: "FI"
            },
            {
            name: "France",
            number: "+33",
            code: "FR"
            },
            {
            name: "French Guiana",
            number: "+594",
            code: "GF"
            },
            {
            name: "French Polynesia",
            number: "+689",
            code: "PF"
            },
            {
            name: "Gabon",
            number: "+241",
            code: "GA"
            },
            {
            name: "Gambia",
            number: "+220",
            code: "GM"
            },
            {
            name: "Georgia",
            number: "+995",
            code: "GE"
            },
            {
            name: "Germany",
            number: "+49",
            code: "DE"
            },
            {
            name: "Ghana",
            number: "+233",
            code: "GH"
            },
            {
            name: "Gibraltar",
            number: "+350",
            code: "GI"
            },
            {
            name: "Greece",
            number: "+30",
            code: "GR"
            },
            {
            name: "Greenland",
            number: "+299",
            code: "GL"
            },
            {
            name: "Grenada",
            number: "+1473",
            code: "GD"
            },
            {
            name: "Guadeloupe",
            number: "+590",
            code: "GP"
            },
            {
            name: "Guam",
            number: "+1671",
            code: "GU"
            },
            {
            name: "Guatemala",
            number: "+502",
            code: "GT"
            },
            {
            name: "Guernsey",
            number: "+44",
            code: "GG"
            },
            {
            name: "Guinea",
            number: "+224",
            code: "GN"
            },
            {
            name: "Guinea-Bissau",
            number: "+245",
            code: "GW"
            },
            {
            name: "Guyana",
            number: "+595",
            code: "GY"
            },
            {
            name: "Haiti",
            number: "+509",
            code: "HT"
            },
            {
            name: "Holy See (Vatican City State)",
            number: "+379",
            code: "VA"
            },
            {
            name: "Honduras",
            number: "+504",
            code: "HN"
            },
            {
            name: "Hong Kong",
            number: "+852",
            code: "HK"
            },
            {
            name: "Hungary",
            number: "+36",
            code: "HU"
            },
            {
            name: "Iceland",
            number: "+354",
            code: "IS"
            },
            {
            name: "India",
            number: "+91",
            code: "IN"
            },
            {
            name: "Indonesia",
            number: "+62",
            code: "ID"
            },
            {
            name: "Iran, Islamic Republic of Persian Gulf",
            number: "+98",
            code: "IR"
            },
            {
            name: "Iraq",
            number: "+964",
            code: "IQ"
            },
            {
            name: "Ireland",
            number: "+353",
            code: "IE"
            },
            {
            name: "Isle of Man",
            number: "+44",
            code: "IM"
            },
            {
            name: "Israel",
            number: "+972",
            code: "IL"
            },
            {
            name: "Italy",
            number: "+39",
            code: "IT"
            },
            {
            name: "Jamaica",
            number: "+1876",
            code: "JM"
            },
            {
            name: "Japan",
            number: "+81",
            code: "JP"
            },
            {
            name: "Jersey",
            number: "+44",
            code: "JE"
            },
            {
            name: "Jordan",
            number: "+962",
            code: "JO"
            },
            {
            name: "Kazakhstan",
            number: "+77",
            code: "KZ"
            },
            {
            name: "Kenya",
            number: "+254",
            code: "KE"
            },
            {
            name: "Kiribati",
            number: "+686",
            code: "KI"
            },
            {
            name: "Korea, Democratic People's Republic of Korea",
            number: "+850",
            code: "KP"
            },
            {
            name: "Korea, Republic of South Korea",
            number: "+82",
            code: "KR"
            },
            {
            name: "Kuwait",
            number: "+965",
            code: "KW"
            },
            {
            name: "Kyrgyzstan",
            number: "+996",
            code: "KG"
            },
            {
            name: "Laos",
            number: "+856",
            code: "LA"
            },
            {
            name: "Latvia",
            number: "+371",
            code: "LV"
            },
            {
            name: "Lebanon",
            number: "+961",
            code: "LB"
            },
            {
            name: "Lesotho",
            number: "+266",
            code: "LS"
            },
            {
            name: "Liberia",
            number: "+231",
            code: "LR"
            },
            {
            name: "Libyan Arab Jamahiriya",
            number: "+218",
            code: "LY"
            },
            {
            name: "Liechtenstein",
            number: "+423",
            code: "LI"
            },
            {
            name: "Lithuania",
            number: "+370",
            code: "LT"
            },
            {
            name: "Luxembourg",
            number: "+352",
            code: "LU"
            },
            {
            name: "Macao",
            number: "+853",
            code: "MO"
            },
            {
            name: "Macedonia",
            number: "+389",
            code: "MK"
            },
            {
            name: "Madagascar",
            number: "+261",
            code: "MG"
            },
            {
            name: "Malawi",
            number: "+265",
            code: "MW"
            },
            {
            name: "Malaysia",
            number: "+60",
            code: "MY"
            },
            {
            name: "Maldives",
            number: "+960",
            code: "MV"
            },
            {
            name: "Mali",
            number: "+223",
            code: "ML"
            },
            {
            name: "Malta",
            number: "+356",
            code: "MT"
            },
            {
            name: "Marshall Islands",
            number: "+692",
            code: "MH"
            },
            {
            name: "Martinique",
            number: "+596",
            code: "MQ"
            },
            {
            name: "Mauritania",
            number: "+222",
            code: "MR"
            },
            {
            name: "Mauritius",
            number: "+230",
            code: "MU"
            },
            {
            name: "Mayotte",
            number: "+262",
            code: "YT"
            },
            {
            name: "Mexico",
            number: "+52",
            code: "MX"
            },
            {
            name: "Micronesia, Federated States of Micronesia",
            number: "+691",
            code: "FM"
            },
            {
            name: "Moldova",
            number: "+373",
            code: "MD"
            },
            {
            name: "Monaco",
            number: "+377",
            code: "MC"
            },
            {
            name: "Mongolia",
            number: "+976",
            code: "MN"
            },
            {
            name: "Montenegro",
            number: "+382",
            code: "ME"
            },
            {
            name: "Montserrat",
            number: "+1664",
            code: "MS"
            },
            {
            name: "Morocco",
            number: "+212",
            code: "MA"
            },
            {
            name: "Mozambique",
            number: "+258",
            code: "MZ"
            },
            {
            name: "Myanmar",
            number: "+95",
            code: "MM"
            },
            {
            name: "Namibia",
            number: "+264",
            code: "NA"
            },
            {
            name: "Nauru",
            number: "+674",
            code: "NR"
            },
            {
            name: "Nepal",
            number: "+977",
            code: "NP"
            },
            {
            name: "Netherlands",
            number: "+31",
            code: "NL"
            },
            {
            name: "Netherlands Antilles",
            number: "+599",
            code: "AN"
            },
            {
            name: "New Caledonia",
            number: "+687",
            code: "NC"
            },
            {
            name: "New Zealand",
            number: "+64",
            code: "NZ"
            },
            {
            name: "Nicaragua",
            number: "+505",
            code: "NI"
            },
            {
            name: "Niger",
            number: "+227",
            code: "NE"
            },
            {
            name: "Nigeria",
            number: "+234",
            code: "NG"
            },
            {
            name: "Niue",
            number: "+683",
            code: "NU"
            },
            {
            name: "Norfolk Island",
            number: "+672",
            code: "NF"
            },
            {
            name: "Northern Mariana Islands",
            number: "+1670",
            code: "MP"
            },
            {
            name: "Norway",
            number: "+47",
            code: "NO"
            },
            {
            name: "Oman",
            number: "+968",
            code: "OM"
            },
            {
            name: "Pakistan",
            number: "+92",
            code: "PK"
            },
            {
            name: "Palau",
            number: "+680",
            code: "PW"
            },
            {
            name: "Palestinian Territory, Occupied",
            number: "+970",
            code: "PS"
            },
            {
            name: "Panama",
            number: "+507",
            code: "PA"
            },
            {
            name: "Papua New Guinea",
            number: "+675",
            code: "PG"
            },
            {
            name: "Paraguay",
            number: "+595",
            code: "PY"
            },
            {
            name: "Peru",
            number: "+51",
            code: "PE"
            },
            {
            name: "Philippines",
            number: "+63",
            code: "PH"
            },
            {
            name: "Pitcairn",
            number: "+872",
            code: "PN"
            },
            {
            name: "Poland",
            number: "+48",
            code: "PL"
            },
            {
            name: "Portugal",
            number: "+351",
            code: "PT"
            },
            {
            name: "Puerto Rico",
            number: "+1939",
            code: "PR"
            },
            {
            name: "Qatar",
            number: "+974",
            code: "QA"
            },
            {
            name: "Romania",
            number: "+40",
            code: "RO"
            },
            {
            name: "Russia",
            number: "+7",
            code: "RU"
            },
            {
            name: "Rwanda",
            number: "+250",
            code: "RW"
            },
            {
            name: "Reunion",
            number: "+262",
            code: "RE"
            },
            {
            name: "Saint Barthelemy",
            number: "+590",
            code: "BL"
            },
            {
            name: "Saint Helena, Ascension and Tristan Da Cunha",
            number: "+290",
            code: "SH"
            },
            {
            name: "Saint Kitts and Nevis",
            number: "+1869",
            code: "KN"
            },
            {
            name: "Saint Lucia",
            number: "+1758",
            code: "LC"
            },
            {
            name: "Saint Martin",
            number: "+590",
            code: "MF"
            },
            {
            name: "Saint Pierre and Miquelon",
            number: "+508",
            code: "PM"
            },
            {
            name: "Saint Vincent and the Grenadines",
            number: "+1784",
            code: "VC"
            },
            {
            name: "Samoa",
            number: "+685",
            code: "WS"
            },
            {
            name: "San Marino",
            number: "+378",
            code: "SM"
            },
            {
            name: "Sao Tome and Principe",
            number: "+239",
            code: "ST"
            },
            {
            name: "Saudi Arabia",
            number: "+966",
            code: "SA"
            },
            {
            name: "Senegal",
            number: "+221",
            code: "SN"
            },
            {
            name: "Serbia",
            number: "+381",
            code: "RS"
            },
            {
            name: "Seychelles",
            number: "+248",
            code: "SC"
            },
            {
            name: "Sierra Leone",
            number: "+232",
            code: "SL"
            },
            {
            name: "Singapore",
            number: "+65",
            code: "SG"
            },
            {
            name: "Slovakia",
            number: "+421",
            code: "SK"
            },
            {
            name: "Slovenia",
            number: "+386",
            code: "SI"
            },
            {
            name: "Solomon Islands",
            number: "+677",
            code: "SB"
            },
            {
            name: "Somalia",
            number: "+252",
            code: "SO"
            },
            {
            name: "South Africa",
            number: "+27",
            code: "ZA"
            },
            {
            name: "South Sudan",
            number: "+211",
            code: "SS"
            },
            {
            name: "South Georgia and the South Sandwich Islands",
            number: "+500",
            code: "GS"
            },
            {
            name: "Spain",
            number: "+34",
            code: "ES"
            },
            {
            name: "Sri Lanka",
            number: "+94",
            code: "LK"
            },
            {
            name: "Sudan",
            number: "+249",
            code: "SD"
            },
            {
            name: "Suriname",
            number: "+597",
            code: "SR"
            },
            {
            name: "Svalbard and Jan Mayen",
            number: "+47",
            code: "SJ"
            },
            {
            name: "Swaziland",
            number: "+268",
            code: "SZ"
            },
            {
            name: "Sweden",
            number: "+46",
            code: "SE"
            },
            {
            name: "Switzerland",
            number: "+41",
            code: "CH"
            },
            {
            name: "Syrian Arab Republic",
            number: "+963",
            code: "SY"
            },
            {
            name: "Taiwan",
            number: "+886",
            code: "TW"
            },
            {
            name: "Tajikistan",
            number: "+992",
            code: "TJ"
            },
            {
            name: "Tanzania, United Republic of Tanzania",
            number: "+255",
            code: "TZ"
            },
            {
            name: "Thailand",
            number: "+66",
            code: "TH"
            },
            {
            name: "Timor-Leste",
            number: "+670",
            code: "TL"
            },
            {
            name: "Togo",
            number: "+228",
            code: "TG"
            },
            {
            name: "Tokelau",
            number: "+690",
            code: "TK"
            },
            {
            name: "Tonga",
            number: "+676",
            code: "TO"
            },
            {
            name: "Trinidad and Tobago",
            number: "+1868",
            code: "TT"
            },
            {
            name: "Tunisia",
            number: "+216",
            code: "TN"
            },
            {
            name: "Turkey",
            number: "+90",
            code: "TR"
            },
            {
            name: "Turkmenistan",
            number: "+993",
            code: "TM"
            },
            {
            name: "Turks and Caicos Islands",
            number: "+1649",
            code: "TC"
            },
            {
            name: "Tuvalu",
            number: "+688",
            code: "TV"
            },
            {
            name: "Uganda",
            number: "+256",
            code: "UG"
            },
            {
            name: "Ukraine",
            number: "+380",
            code: "UA"
            },
            {
            name: "United Arab Emirates",
            number: "+971",
            code: "AE"
            },
            {
            name: "United Kingdom",
            number: "+44",
            code: "GB"
            },
            {
            name: "United States",
            number: "+1",
            code: "US"
            },
            {
            name: "Uruguay",
            number: "+598",
            code: "UY"
            },
            {
            name: "Uzbekistan",
            number: "+998",
            code: "UZ"
            },
            {
            name: "Vanuatu",
            number: "+678",
            code: "VU"
            },
            {
            name: "Venezuela, Bolivarian Republic of Venezuela",
            number: "+58",
            code: "VE"
            },
            {
            name: "Vietnam",
            number: "+84",
            code: "VN"
            },
            {
            name: "Virgin Islands, British",
            number: "+1284",
            code: "VG"
            },
            {
            name: "Virgin Islands, U.S.",
            number: "+1340",
            code: "VI"
            },
            {
            name: "Wallis and Futuna",
            number: "+681",
            code: "WF"
            },
            {
            name: "Yemen",
            number: "+967",
            code: "YE"
            },
            {
            name: "Zambia",
            number: "+260",
            code: "ZM"
            },
            {
            name: "Zimbabwe",
            number: "+263",
            code: "ZW"
            }
    ];

    public static timezone_json = {"BD": [{"tzid": "Asia/Dhaka", "name": "Bangladesh"}],
                         "BE": [{"tzid": "Europe/Brussels", "name": "Romance"}],
                         "BF": [{"tzid": "Africa/Abidjan", "name": "Greenwich"}], 
                         "BG": [{"tzid": "Europe/Sofia", "name": "FLE"}], 
                         "BA": [{"tzid": "Europe/Belgrade", "name": "Central Europe"}], 
                         "BB": [{"tzid": "America/Barbados", "name": "SA Western"}], "WF": [{"tzid": "Pacific/Wallis", "name": "UTC+12"}], "BL": [{"tzid": "America/Port_of_Spain", "name": "SA Western"}], "BM": [{"tzid": "Atlantic/Bermuda", "name": "Atlantic"}], "BN": [{"tzid": "Asia/Brunei", "name": "Singapore"}], "BO": [{"tzid": "America/La_Paz", "name": "SA Western"}], "JP": [{"tzid": "Asia/Tokyo", "name": "Tokyo"}], "BI": [{"tzid": "Africa/Maputo", "name": "South Africa"}], "BJ": [{"tzid": "Africa/Lagos", "name": "W. Central Africa"}], "BT": [{"tzid": "Asia/Thimphu", "name": "Bangladesh"}], "JM": [{"tzid": "America/Jamaica", "name": "SA Pacific"}], "JO": [{"tzid": "Asia/Amman", "name": "Jordan"}], "WS": [{"tzid": "Pacific/Apia", "name": "Samoa"}], "BQ": [{"tzid": "America/Curacao", "name": "SA Western"}], "BR": [{"tzid": "America/Noronha", "name": "UTC-02"}, {"tzid": "America/Belem", "name": "Belem"}, {"tzid": "America/Fortaleza", "name": "Fortaleza"}, {"tzid": "America/Recife", "name": "Recife"}, {"tzid": "America/Araguaina", "name": "Araguaina"}, {"tzid": "America/Maceio", "name": "Maceio"}, {"tzid": "America/Bahia", "name": "Bahia"}, {"tzid": "America/Sao_Paulo", "name": "Sao Paulo"}, {"tzid": "America/Campo_Grande", "name": "Campo Grande"}, {"tzid": "America/Cuiaba", "name": "Cuiaba"}, {"tzid": "America/Porto_Velho", "name": "Velho"}, {"tzid": "America/Boa_Vista", "name": "Boa Vista"}, {"tzid": "America/Manaus", "name": "Manaus"}, {"tzid": "America/Rio_Branco", "name": "Rio Branco"}], "BS": [{"tzid": "America/Nassau", "name": "Eastern"}], "JE": [{"tzid": "Europe/London", "name": "GMT"}], "BY": [{"tzid": "Europe/Minsk", "name": "Belarus"}], "BZ": [{"tzid": "America/Belize", "name": "Central America"}], "RU": [{"tzid": "Europe/Kaliningrad", "name": "Kaliningrad"}, {"tzid": "Europe/Moscow", "name": "Russian"}, {"tzid": "Europe/Simferopol", "name": "Russian"}, {"tzid": "Europe/Volgograd", "name": "Russian"}, {"tzid": "Europe/Samara", "name": "Russia Zone 3"}, {"tzid": "Asia/Yekaterinburg", "name": "Ekaterinburg"}, {"tzid": "Asia/Omsk", "name": "N. Central Asia"}, {"tzid": "Asia/Novosibirsk", "name": "N. Central Asia"}, {"tzid": "Asia/Novokuznetsk", "name": "North Asia"}, {"tzid": "Asia/Krasnoyarsk", "name": "North Asia"}, {"tzid": "Asia/Irkutsk", "name": "North Asia East"}, {"tzid": "Asia/Chita", "name": "Yakutsk"}, {"tzid": "Asia/Yakutsk", "name": "Yakutsk"}, {"tzid": "Asia/Khandyga", "name": "Yakutsk"}, {"tzid": "Asia/Vladivostok", "name": "Vladivostok"}, {"tzid": "Asia/Ust-Nera", "name": "Vladivostok"}, {"tzid": "Asia/Magadan", "name": "Magadan"}, {"tzid": "Asia/Sakhalin", "name": "Vladivostok"}, {"tzid": "Asia/Srednekolymsk", "name": "Russia Zone 10"}, {"tzid": "Asia/Kamchatka", "name": "Russia Zone 11"}, {"tzid": "Asia/Anadyr", "name": "Russia Zone 11"}], "RW": [{"tzid": "Africa/Maputo", "name": "South Africa"}], "RS": [{"tzid": "Europe/Belgrade", "name": "Central Europe"}], "LT": [{"tzid": "Europe/Vilnius", "name": "FLE"}], "RE": [{"tzid": "Indian/Reunion", "name": "Mauritius"}], "LU": [{"tzid": "Europe/Luxembourg", "name": "W. Europe"}], "LR": [{"tzid": "Africa/Monrovia", "name": "Greenwich"}], "RO": [{"tzid": "Europe/Bucharest", "name": "GTB"}], "TK": [{"tzid": "Pacific/Fakaofo", "name": "Tonga"}], "GW": [{"tzid": "Africa/Bissau", "name": "Greenwich"}], "GU": [{"tzid": "Pacific/Guam", "name": "West Pacific"}], "GT": [{"tzid": "America/Guatemala", "name": "Central America"}], "GR": [{"tzid": "Europe/Athens", "name": "GTB"}], "GQ": [{"tzid": "Africa/Lagos", "name": "W. Central Africa"}], "GP": [{"tzid": "America/Port_of_Spain", "name": "SA Western"}], "BH": [{"tzid": "Asia/Qatar", "name": "Arab"}], "GY": [{"tzid": "America/Guyana", "name": "SA Western"}], "GG": [{"tzid": "Europe/London", "name": "GMT"}], "GF": [{"tzid": "America/Cayenne", "name": "SA Eastern"}], "GE": [{"tzid": "Asia/Tbilisi", "name": "Georgian"}], "GD": [{"tzid": "America/Port_of_Spain", "name": "SA Western"}], "GB": [{"tzid": "Europe/London", "name": "GMT"}], "GA": [{"tzid": "Africa/Lagos", "name": "W. Central Africa"}], "GN": [{"tzid": "Africa/Abidjan", "name": "Greenwich"}], "GM": [{"tzid": "Africa/Abidjan", "name": "Greenwich"}], "GL": [{"tzid": "America/Godthab", "name": "Greenland"}, {"tzid": "America/Danmarkshavn", "name": "UTC"}, {"tzid": "America/Scoresbysund", "name": "Azores"}, {"tzid": "America/Thule", "name": "Atlantic"}], "GI": [{"tzid": "Europe/Gibraltar", "name": "W. Europe"}], "GH": [{"tzid": "Africa/Accra", "name": "Greenwich"}], "OM": [{"tzid": "Asia/Dubai", "name": "Arabian"}], "BW": [{"tzid": "Africa/Maputo", "name": "South Africa"}], "HR": [{"tzid": "Europe/Belgrade", "name": "Central Europe"}], "HT": [{"tzid": "America/Port-au-Prince", "name": "Eastern"}], "HU": [{"tzid": "Europe/Budapest", "name": "Central Europe"}], "HK": [{"tzid": "Asia/Hong_Kong", "name": "China"}], "HN": [{"tzid": "America/Tegucigalpa", "name": "Central America"}], "LV": [{"tzid": "Europe/Riga", "name": "FLE"}], "AD": [{"tzid": "Europe/Andorra", "name": "W. Europe"}], "PR": [{"tzid": "America/Puerto_Rico", "name": "SA Western"}], "PS": [{"tzid": "Asia/Gaza", "name": "Palestine Time"}], "PW": [{"tzid": "Pacific/Palau", "name": "Tokyo"}], "PT": [{"tzid": "Europe/Lisbon", "name": "Lisbon"}, {"tzid": "Atlantic/Azores", "name": "Azores"}], "KR": [{"tzid": "Asia/Seoul", "name": "Korea"}], "PY": [{"tzid": "America/Asuncion", "name": "Paraguay"}], "IQ": [{"tzid": "Asia/Baghdad", "name": "Arabic"}], "PA": [{"tzid": "America/Panama", "name": "SA Pacific"}], "PF": [{"tzid": "Pacific/Tahiti", "name": "Hawaiian"}], "PG": [{"tzid": "Pacific/Port_Moresby", "name": "West Pacific"}, {"tzid": "Pacific/Bougainville", "name": "Central Pacific"}], "PE": [{"tzid": "America/Lima", "name": "SA Pacific"}], "PK": [{"tzid": "Asia/Karachi", "name": "Pakistan"}], "PH": [{"tzid": "Asia/Manila", "name": "Singapore"}], "PN": [{"tzid": "Pacific/Pitcairn", "name": "Pitcairn Time"}], "PL": [{"tzid": "Europe/Warsaw", "name": "Central European"}], "PM": [{"tzid": "America/Miquelon", "name": "Miquelon Time"}], "ZM": [{"tzid": "Africa/Maputo", "name": "South Africa"}], "EH": [{"tzid": "Africa/El_Aaiun", "name": "Morocco"}], "EE": [{"tzid": "Europe/Tallinn", "name": "FLE"}], "EG": [{"tzid": "Africa/Cairo", "name": "Egypt"}], "ZA": [{"tzid": "Africa/Johannesburg", "name": "South Africa"}], "EC": [{"tzid": "America/Guayaquil", "name": "SA Pacific"}, {"tzid": "Pacific/Galapagos", "name": "Central America"}], "AL": [{"tzid": "Europe/Tirane", "name": "Central Europe"}], "AO": [{"tzid": "Africa/Lagos", "name": "W. Central Africa"}], "KZ": [{"tzid": "Asia/Almaty", "name": "Almaty"}, {"tzid": "Asia/Aqtobe", "name": "Aqtobe"}, {"tzid": "Asia/Aqtau", "name": "Aqtau"}], "ET": [{"tzid": "Africa/Nairobi", "name": "E. Africa"}], "SO": [{"tzid": "Africa/Nairobi", "name": "E. Africa"}], "ZW": [{"tzid": "Africa/Maputo", "name": "South Africa"}], "KY": [{"tzid": "America/Panama", "name": "SA Pacific"}], "ES": [{"tzid": "Europe/Madrid", "name": "Madrid"}, {"tzid": "Africa/Ceuta", "name": "Ceuta"}, {"tzid": "Atlantic/Canary", "name": "GMT"}], "ER": [{"tzid": "Africa/Nairobi", "name": "E. Africa"}], "ME": [{"tzid": "Europe/Belgrade", "name": "Central Europe"}], "MD": [{"tzid": "Europe/Chisinau", "name": "E. Europe"}], "MG": [{"tzid": "Africa/Nairobi", "name": "E. Africa"}], "MF": [{"tzid": "America/Port_of_Spain", "name": "SA Western"}], "MA": [{"tzid": "Africa/Casablanca", "name": "Morocco"}], "MC": [{"tzid": "Europe/Monaco", "name": "W. Europe"}], "UZ": [{"tzid": "Asia/Tashkent", "name": "Tashkent"}], "MM": [{"tzid": "Asia/Rangoon", "name": "Myanmar"}], "ML": [{"tzid": "Africa/Abidjan", "name": "Greenwich"}], "MO": [{"tzid": "Asia/Macau", "name": "China"}], "MN": [{"tzid": "Asia/Ulaanbaatar", "name": "Ulaanbaatar"}, {"tzid": "Asia/Choibalsan", "name": "Choibalsan"}], "MH": [{"tzid": "Pacific/Majuro", "name": "Majuro"}, {"tzid": "Pacific/Kwajalein", "name": "Kwajalein"}], "MK": [{"tzid": "Europe/Belgrade", "name": "Central Europe"}], "UM": [{"tzid": "Pacific/Pago_Pago", "name": "UTC-11"}, {"tzid": "Pacific/Wake", "name": "UTC+12"}, {"tzid": "Pacific/Honolulu", "name": "Hawaiian"}], "MT": [{"tzid": "Europe/Malta", "name": "W. Europe"}], "MW": [{"tzid": "Africa/Maputo", "name": "South Africa"}], "MV": [{"tzid": "Indian/Maldives", "name": "West Asia"}], "MQ": [{"tzid": "America/Martinique", "name": "SA Western"}], "MP": [{"tzid": "Pacific/Guam", "name": "West Pacific"}], "MS": [{"tzid": "America/Port_of_Spain", "name": "SA Western"}], "MR": [{"tzid": "Africa/Abidjan", "name": "Greenwich"}], "AU": [{"tzid": "Antarctica/Macquarie", "name": "Central Pacific"}, {"tzid": "Australia/Hobart", "name": "Eastern - Hobart"}, {"tzid": "Australia/Sydney", "name": "Eastern - Sydney"}, {"tzid": "Australia/Brisbane", "name": "Eastern - Brisbane"}, {"tzid": "Australia/Adelaide", "name": "Central- Adelaide"}, {"tzid": "Australia/Darwin", "name": "Central - Darwin"}, {"tzid": "Australia/Perth", "name": "Western"}], "UG": [{"tzid": "Africa/Nairobi", "name": "E. Africa"}], "MY": [{"tzid": "Asia/Kuala_Lumpur", "name": "Kuala Lumpur"}], "MX": [{"tzid": "America/Mexico_City", "name": "Central - Mexico City"}, {"tzid": "America/Cancun", "name": "Eastern"}, {"tzid": "America/Chihuahua", "name": "Mountain - Chihuahua"}, {"tzid": "America/Hermosillo", "name": "Mountain - Hermosillo"}, {"tzid": "America/Tijuana", "name": "Pacific"}], "VU": [{"tzid": "Pacific/Efate", "name": "Central Pacific"}], "FR": [{"tzid": "Europe/Paris", "name": "Romance"}], "AW": [{"tzid": "America/Curacao", "name": "SA Western"}], "SH": [{"tzid": "Africa/Abidjan", "name": "Greenwich"}], "AF": [{"tzid": "Asia/Kabul", "name": "Afghanistan"}], "AX": [{"tzid": "Europe/Helsinki", "name": "FLE"}], "FI": [{"tzid": "Europe/Helsinki", "name": "FLE"}], "FJ": [{"tzid": "Pacific/Fiji", "name": "Fiji"}], "FK": [{"tzid": "Atlantic/Stanley", "name": "SA Eastern"}], "FM": [{"tzid": "Pacific/Kosrae", "name": "Central Pacific"}], "FO": [{"tzid": "Atlantic/Faroe", "name": "Faroe Time"}], "NI": [{"tzid": "America/Managua", "name": "Central America"}], "NL": [{"tzid": "Europe/Amsterdam", "name": "W. Europe"}], "NO": [{"tzid": "Europe/Oslo", "name": "W. Europe"}], "NA": [{"tzid": "Africa/Windhoek", "name": "Namibia"}], "NC": [{"tzid": "Pacific/Noumea", "name": "Central Pacific"}], "NE": [{"tzid": "Africa/Lagos", "name": "W. Central Africa"}], "NF": [{"tzid": "Pacific/Norfolk", "name": "Central Pacific"}], "NG": [{"tzid": "Africa/Lagos", "name": "W. Central Africa"}], "NZ": [{"tzid": "Pacific/Auckland", "name": "New Zealand"}], "NP": [{"tzid": "Asia/Kathmandu", "name": "Nepal Time"}], "NR": [{"tzid": "Pacific/Nauru", "name": "UTC+12"}], "NU": [{"tzid": "Pacific/Niue", "name": "UTC-11"}], "CK": [{"tzid": "Pacific/Rarotonga", "name": "Hawaiian"}], "CI": [{"tzid": "Africa/Abidjan", "name": "Greenwich"}], "CH": [{"tzid": "Europe/Zurich", "name": "W. Europe"}], "CO": [{"tzid": "America/Bogota", "name": "SA Pacific"}], "CN": [{"tzid": "Asia/Shanghai", "name": "China"}, {"tzid": "Asia/Urumqi", "name": "Central Asia"}], "CM": [{"tzid": "Africa/Lagos", "name": "W. Central Africa"}], "CL": [{"tzid": "America/Santiago", "name": "Santiago"}, {"tzid": "Pacific/Easter", "name": "Easter Island"}], "CC": [{"tzid": "Indian/Cocos", "name": "Myanmar"}], "CA": [{"tzid": "America/St_Johns", "name": "Newfoundland"}, {"tzid": "America/Halifax", "name": "Atlantic - Halifax"}, {"tzid": "America/Toronto", "name": "Eastern - Toronto"}, {"tzid": "America/Iqaluit", "name": "Eastern - Iqaluit"}, {"tzid": "America/Winnipeg", "name": "Central - Winnipeg"}, {"tzid": "America/Regina", "name": "Central - Regina"}, {"tzid": "America/Edmonton", "name": "Mountain - Edmonton"}, {"tzid": "America/Yellowknife", "name": "Mountain - Yellowknife"}, {"tzid": "America/Dawson_Creek", "name": "Dawson Creek"}, {"tzid": "America/Vancouver", "name": "Pacific - Vancouver"}, {"tzid": "America/Whitehorse", "name": "Pacific - Whitehorse"}], "CG": [{"tzid": "Africa/Lagos", "name": "W. Central Africa"}], "CF": [{"tzid": "Africa/Lagos", "name": "W. Central Africa"}], "CD": [{"tzid": "Africa/Maputo", "name": "South Africa"}, {"tzid": "Africa/Lagos", "name": "W. Central Africa"}], "CZ": [{"tzid": "Europe/Prague", "name": "Central Europe"}], "CY": [{"tzid": "Asia/Nicosia", "name": "GTB"}], "CX": [{"tzid": "Indian/Christmas", "name": "SE Asia"}], "CR": [{"tzid": "America/Costa_Rica", "name": "Central America"}], "CW": [{"tzid": "America/Curacao", "name": "SA Western"}], "CV": [{"tzid": "Atlantic/Cape_Verde", "name": "Cape Verde"}], "CU": [{"tzid": "America/Havana", "name": "Eastern"}], "SZ": [{"tzid": "Africa/Johannesburg", "name": "South Africa"}], "SY": [{"tzid": "Asia/Damascus", "name": "Syria"}], "SX": [{"tzid": "America/Curacao", "name": "SA Western"}], "KG": [{"tzid": "Asia/Bishkek", "name": "Central Asia"}], "KE": [{"tzid": "Africa/Nairobi", "name": "E. Africa"}], "SS": [{"tzid": "Africa/Khartoum", "name": "E. Africa"}], "SR": [{"tzid": "America/Paramaribo", "name": "SA Eastern"}], "KI": [{"tzid": "Pacific/Tarawa", "name": "UTC+12"}, {"tzid": "Pacific/Enderbury", "name": "Tonga"}, {"tzid": "Pacific/Kiritimati", "name": "Line Islands"}], "KH": [{"tzid": "Asia/Bangkok", "name": "SE Asia"}], "SV": [{"tzid": "America/El_Salvador", "name": "Central America"}], "KM": [{"tzid": "Africa/Nairobi", "name": "E. Africa"}], "ST": [{"tzid": "Africa/Abidjan", "name": "Greenwich"}], "SK": [{"tzid": "Europe/Prague", "name": "Central Europe"}], "SJ": [{"tzid": "Europe/Oslo", "name": "W. Europe"}], "SI": [{"tzid": "Europe/Belgrade", "name": "Central Europe"}], "KP": [{"tzid": "Asia/Pyongyang", "name": "North Korea"}], "KW": [{"tzid": "Asia/Riyadh", "name": "Arab"}], "SN": [{"tzid": "Africa/Abidjan", "name": "Greenwich"}], "SM": [{"tzid": "Europe/Rome", "name": "W. Europe"}], "SL": [{"tzid": "Africa/Abidjan", "name": "Greenwich"}], "SC": [{"tzid": "Indian/Mahe", "name": "Mauritius"}], "SB": [{"tzid": "Pacific/Guadalcanal", "name": "Central Pacific"}], "SA": [{"tzid": "Asia/Riyadh", "name": "Arab"}], "SG": [{"tzid": "Asia/Singapore", "name": "Singapore"}], "SE": [{"tzid": "Europe/Stockholm", "name": "W. Europe"}], "SD": [{"tzid": "Africa/Khartoum", "name": "E. Africa"}], "DO": [{"tzid": "America/Santo_Domingo", "name": "SA Western"}], "DM": [{"tzid": "America/Port_of_Spain", "name": "SA Western"}], "DJ": [{"tzid": "Africa/Nairobi", "name": "E. Africa"}], "DK": [{"tzid": "Europe/Copenhagen", "name": "Romance"}], "DE": [{"tzid": "Europe/Berlin", "name": "Berlin"}], "YE": [{"tzid": "Asia/Riyadh", "name": "Arab"}], "AT": [{"tzid": "Europe/Vienna", "name": "W. Europe"}], "DZ": [{"tzid": "Africa/Algiers", "name": "W. Central Africa"}], "US": [{"tzid": "America/New_York", "name": "Eastern"}, {"tzid": "America/Chicago", "name": "Central"}, {"tzid": "America/Denver", "name": "Mountain"}, {"tzid": "America/Phoenix", "name": "Mountain - AZ"}, {"tzid": "America/Los_Angeles", "name": "Pacific"}, {"tzid": "America/Anchorage", "name": "Alaskan"}, {"tzid": "Pacific/Honolulu", "name": "Hawaiian"}], "UY": [{"tzid": "America/Montevideo", "name": "Montevideo"}], "YT": [{"tzid": "Africa/Nairobi", "name": "E. Africa"}], "MU": [{"tzid": "Indian/Mauritius", "name": "Mauritius"}], "KN": [{"tzid": "America/Port_of_Spain", "name": "SA Western"}], "LB": [{"tzid": "Asia/Beirut", "name": "Middle East"}], "LC": [{"tzid": "America/Port_of_Spain", "name": "SA Western"}], "LA": [{"tzid": "Asia/Bangkok", "name": "SE Asia"}], "TV": [{"tzid": "Pacific/Funafuti", "name": "UTC+12"}], "TW": [{"tzid": "Asia/Taipei", "name": "Taipei"}], "TT": [{"tzid": "America/Port_of_Spain", "name": "SA Western"}], "TR": [{"tzid": "Europe/Istanbul", "name": "Turkey"}], "LK": [{"tzid": "Asia/Colombo", "name": "Sri Lanka"}], "LI": [{"tzid": "Europe/Zurich", "name": "W. Europe"}], "TN": [{"tzid": "Africa/Tunis", "name": "W. Central Africa"}], "TO": [{"tzid": "Pacific/Tongatapu", "name": "Tonga"}], "TL": [{"tzid": "Asia/Dili", "name": "Tokyo"}], "TM": [{"tzid": "Asia/Ashgabat", "name": "West Asia"}], "TJ": [{"tzid": "Asia/Dushanbe", "name": "West Asia"}], "LS": [{"tzid": "Africa/Johannesburg", "name": "South Africa"}], "TH": [{"tzid": "Asia/Bangkok", "name": "SE Asia"}], "TG": [{"tzid": "Africa/Abidjan", "name": "Greenwich"}], "TD": [{"tzid": "Africa/Ndjamena", "name": "W. Central Africa"}], "TC": [{"tzid": "America/Grand_Turk", "name": "SA Western"}], "LY": [{"tzid": "Africa/Tripoli", "name": "Libya"}], "VA": [{"tzid": "Europe/Rome", "name": "W. Europe"}], "VC": [{"tzid": "America/Port_of_Spain", "name": "SA Western"}], "AE": [{"tzid": "Asia/Dubai", "name": "Arabian"}], "VE": [{"tzid": "America/Caracas", "name": "Venezuela"}], "AG": [{"tzid": "America/Port_of_Spain", "name": "SA Western"}], "VG": [{"tzid": "America/Port_of_Spain", "name": "SA Western"}], "AI": [{"tzid": "America/Port_of_Spain", "name": "SA Western"}], "VI": [{"tzid": "America/Port_of_Spain", "name": "SA Western"}], "IS": [{"tzid": "Atlantic/Reykjavik", "name": "Greenwich"}], "IR": [{"tzid": "Asia/Tehran", "name": "Iran"}], "AM": [{"tzid": "Asia/Yerevan", "name": "Caucasus"}], "IT": [{"tzid": "Europe/Rome", "name": "W. Europe"}], "VN": [{"tzid": "Asia/Bangkok", "name": "SE Asia"}], "AS": [{"tzid": "Pacific/Pago_Pago", "name": "UTC-11"}], "AR": [{"tzid": "America/Argentina/Salta", "name": "Argentina"}], "IM": [{"tzid": "Europe/London", "name": "GMT"}], "IL": [{"tzid": "Asia/Jerusalem", "name": "Israel"}], "IO": [{"tzid": "Indian/Chagos", "name": "Central Asia"}], "IN": [{"tzid": "Asia/Kolkata", "name": "India"}], "TZ": [{"tzid": "Africa/Nairobi", "name": "E. Africa"}], "AZ": [{"tzid": "Asia/Baku", "name": "Azerbaijan"}], "IE": [{"tzid": "Europe/Dublin", "name": "GMT"}], "ID": [{"tzid": "Asia/Jakarta", "name": "Jakarta"}, {"tzid": "Asia/Makassar", "name": "Singapore"}, {"tzid": "Asia/Jayapura", "name": "Tokyo"}], "UA": [{"tzid": "Europe/Kiev", "name": "Kiev"}], "QA": [{"tzid": "Asia/Qatar", "name": "Arab"}], "MZ": [{"tzid": "Africa/Maputo", "name": "South Africa"}]}
}